/** Replacement parts: JSON fetch, AND search, pagination. Fits = Liquid metafield → titles (product picker or text). Vanilla ES5. */
;(function () {
  'use strict'

  var PAGE = 250
  var STOP = /^(?:the|a|an|and|or|for|to|of|in|on|at|my|is|it|be|are|was|were|your|their|that|this|these|those)$/i

  function R() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
  }

  /** Shopify shop.money_format — matches theme.Currency.formatMoney cases we use */
  function money(cents, fmt) {
    fmt = fmt || (window.theme && window.theme.moneyFormat) || '{{amount}}'
    function fd(n, prec, thou, dec) {
      thou = thou || ','
      dec = dec || '.'
      if (n == null || isNaN(n)) return '0'
      n = (n / 100).toFixed(prec)
      var p = n.split('.')
      p[0] = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou)
      return p[1] ? p[0] + dec + p[1] : p[0]
    }
    var ph = /\{\{\s*(\w+)\s*\}\}/
    var m = fmt.match(ph)
    if (!m) return String(cents / 100)
    var k = m[1]
    var v
    switch (k) {
      case 'amount':
        v = fd(cents, 2)
        break
      case 'amount_no_decimals':
        v = fd(cents, 0)
        break
      case 'amount_with_comma_separator':
        v = fd(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        v = fd(cents, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        v = fd(cents, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        v = fd(cents, 2, "'")
        break
      default:
        v = fd(cents, 2)
    }
    return fmt.replace(ph, v)
  }

  function vc(v) {
    if (!v || v.price == null) return 0
    var p = v.price
    return typeof p === 'number' ? (p > 1e6 ? Math.round(p) : Math.round(p * 100)) : Math.round(parseFloat(String(p)) * 100) || 0
  }

  function cmp(v) {
    if (!v || v.compare_at_price == null) return 0
    var p = v.compare_at_price
    return typeof p === 'number' ? Math.round(p * 100) : Math.round(parseFloat(String(p)) * 100) || 0
  }

  function tags(t) {
    return t
      ? String(t)
          .split(',')
          .map(function (x) {
            return x.trim()
          })
          .filter(Boolean)
      : []
  }

  function strip(h) {
    if (!h) return ''
    var d = document.createElement('div')
    d.innerHTML = h
    return (d.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
  }

  function mlines(raw) {
    if (raw == null || raw === '') return []
    if (Array.isArray(raw)) return raw.map(String).map(function (s) { return s.trim() }).filter(Boolean)
    var s = String(raw).trim()
    if (!s) return []
    try {
      var j = JSON.parse(s)
      if (Array.isArray(j)) return j.map(String).map(function (x) { return x.trim() }).filter(Boolean)
    } catch (e) {}
    return s.split(/\r?\n/).map(function (l) { return l.trim() }).filter(Boolean)
  }

  /** Fits metafield: [{ title, handle? }] from Liquid, legacy strings/newlines */
  function fitsItems(raw) {
    if (raw == null || raw === '') return []
    if (Array.isArray(raw)) {
      if (!raw.length) return []
      if (typeof raw[0] === 'object' && raw[0] !== null && raw[0].title != null)
        return raw
          .map(function (item) {
            return {
              title: String(item.title || '').trim(),
              handle: item.handle != null && String(item.handle).trim() !== '' ? String(item.handle).trim() : ''
            }
          })
          .filter(function (x) {
            return x.title
          })
      return raw
        .map(function (s) {
          return { title: String(s).trim(), handle: '' }
        })
        .filter(function (x) {
          return x.title
        })
    }
    return mlines(raw).map(function (t) {
      return { title: t, handle: '' }
    })
  }

  function fitsHayText(raw) {
    var items = fitsItems(raw),
      t = []
    for (var i = 0; i < items.length; i++) t.push(items[i].title)
    return t.join(' ')
  }

  function hay(p, meta) {
    var h = [
      (p.title || '').toLowerCase(),
      strip(p.body_html),
      tags(p.tags).join(' ').toLowerCase(),
      String(p.vendor || '').toLowerCase(),
      String(p.product_type || p.type || '').toLowerCase(),
      (p.variants || [])
        .map(function (v) {
          return [v.sku, v.title].join(' ')
        })
        .join(' ')
        .toLowerCase()
    ].join(' ')
    if (meta && meta[p.id] != null) h += ' ' + fitsHayText(meta[p.id]).toLowerCase()
    return h.replace(/\s+/g, ' ').trim()
  }

  function toks(q) {
    if (!q) return []
    return q
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter(function (w) {
        return w && !STOP.test(w)
      })
  }

  function matchAll(h, q) {
    var t = toks(q)
    if (!t.length) return true
    for (var i = 0; i < t.length; i++) if (h.indexOf(t[i]) === -1) return false
    return true
  }

  function img(p) {
    if (p.featured_image && p.featured_image.src) return p.featured_image.src
    if (typeof p.featured_image === 'string') return p.featured_image
    return p.images && p.images[0] && p.images[0].src ? p.images[0].src : ''
  }

  function imgW(src, w) {
    return src ? src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : ''
  }

  function pnReg(p, img0) {
    if (typeof window.pn === 'undefined') window.pn = {}
    if (!window.pn.cP) window.pn.cP = {}
    var vv = []
    ;(p.variants || []).forEach(function (v) {
      var o = { id: v.id, m: v.inventory_management || '', p: v.inventory_policy || '', q: +v.inventory_quantity || 0, r: vc(v) }
      var c = cmp(v)
      if (c) o.s = c
      vv.push(o)
    })
    window.pn.cP[p.id] = { id: p.id, h: p.handle, i: img0 || '', t: tags(p.tags), v: vv }
  }

  function card(p, cfg, meta) {
    var V = p.variants || []
    var fv = V[0]
    var multi = V.length > 1
    var title = esc(p.title)
    var url = R() + 'products/' + encodeURIComponent(p.handle)
    var pr = (window.theme && window.theme.moneyFormat) || '{{amount}}'
    var pm = null
    V.forEach(function (v) {
      var x = vc(v)
      if (pm === null || x < pm) pm = x
    })
    if (pm === null) pm = 0
    var cm = 0
    V.forEach(function (v) {
      var x = cmp(v)
      if (x && (!cm || x < cm)) cm = x
    })
    var sale = cm > pm
    var price = sale
      ? '<strong>' + money(pm, pr) + '</strong> <s>' + money(cm, pr) + '</s>'
      : '<strong>' + money(pm, pr) + '</strong>'
    var fit = ''
    if (cfg.showFits) {
      var items = fitsItems(meta[p.id])
      if (items.length) {
        var bits = []
        for (var fi = 0; fi < items.length; fi++) {
          var it = items[fi],
            t = esc(it.title)
          if (it.handle)
            bits.push(
              '<a class="rp-fits-link" href="' +
                esc(R() + 'products/' + encodeURIComponent(it.handle)) +
                '">' +
                t +
                '</a>'
            )
          else bits.push('<span class="rp-fits-plain">' + t + '</span>')
        }
        fit = '<div class="mt-2 rp-fits-row"><strong class="rp-fits-label">Fits:</strong> ' + bits.join('<br>') + '</div>'
      }
    }
    var bt = cfg.btn
    var view = bt === 'view_only' || bt === 'both' || multi ? '<a class="btn btn-cta-border" href="' + url + '">' + esc(cfg.viewTxt) + '</a>' : ''
    var atc = ''
    if (bt !== 'view_only' && !multi && fv) {
      var ok = fv.available
      atc =
        '<button type="button" class="btn btn-accent-fill rp-atc-btn" data-rp-atc data-variant-id="' +
        fv.id +
        '" data-product-title="' +
        title +
        '"' +
        (ok ? '' : ' disabled') +
        '>' +
        (ok ? esc(cfg.atcTxt) : 'Sold Out') +
        '</button>'
    }
    var el = document.createElement('div')
    el.className = 'rp-card-wrapper'
    el.innerHTML =
      '<div class="product-card"><a class="product-card__image" href="' +
      url +
      '"><picture><img loading="lazy" src="' +
      esc(imgW(img(p), 600)) +
      '" alt="' +
      title +
      '"></picture></a><div class="product-card__content"><div class="product-card__heading"><h3 class="heading-5"><a href="' +
      url +
      '">' +
      title +
      '</a></h3><div class="product-card__price">' +
      price +
      '</div></div>' +
      fit +
      '<div class="product-card__action">' +
      view +
      atc +
      '</div></div></div>'
    pnReg(p, img(p))
    return el
  }

  function atcBind(sec) {
    if (!sec || sec.dataset.rpAtcD) return
    sec.dataset.rpAtcD = '1'
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rp-atc]')
      if (!b || b.disabled) return
      var id = b.getAttribute('data-variant-id')
      if (!id) return
      var txt = b.textContent.trim()
      var r = R()
      b.textContent = 'Adding...'
      b.disabled = true
      fetch(r + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function (res) {
          return res.ok ? res.json() : res.json().then(function (d) { throw new Error(d.description || 'err') })
        })
        .then(function () {
          b.textContent = '\u2713 Added'
          return fetch(r + 'cart.js').then(function (x) { return x.json() })
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }))
          setTimeout(function () {
            b.textContent = txt
            b.disabled = false
          }, 1500)
        })
        .catch(function () {
          b.textContent = 'Error'
          b.disabled = false
          setTimeout(function () { b.textContent = txt }, 2000)
        })
    })
  }

  function fetchJSON(handle, onChunk) {
    var acc = []
    var n = 1
    function step() {
      return fetch(R() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + PAGE + '&page=' + n)
        .then(function (r) {
          if (!r.ok) throw new Error('x')
          return r.json()
        })
        .then(function (d) {
          var b = (d && d.products) || []
          acc = acc.concat(b)
          if (onChunk) onChunk(acc.slice())
          if (b.length < PAGE) return acc
          n++
          return step()
        })
    }
    return step()
  }

  function boot(m) {
    var id = m.getAttribute('data-section-id')
    if (!id) return
    var gid = function (x) {
      return document.getElementById(x + id)
    }
    var grid = gid('rp-grid-'),
      qEl = gid('rp-search-'),
      clr = gid('rp-clear-'),
      cnt = gid('rp-count-'),
      em = gid('rp-empty-'),
      pgr = gid('rp-pager-'),
      prev = gid('rp-prev-'),
      nxt = gid('rp-next-'),
      note = gid('rp-load-note-')
    var cfg = {}
    try {
      cfg = JSON.parse(document.getElementById('rp-json-' + id).textContent)
    } catch (e) {}
    var meta = {}
    try {
      var me = document.getElementById('rp-fits-meta-' + id)
      if (me && me.textContent) meta = JSON.parse(me.textContent)
    } catch (e) {}
    var partsH = m.getAttribute('data-parts-collection-handle'),
      per = Math.min(72, Math.max(6, cfg.per_page || 24)),
      data = [],
      st = { list: [], pg: 1, load: true }

    atcBind(document.getElementById('rp-catalog-' + id))

    function filt() {
      var q = qEl ? qEl.value.trim() : ''
      return data.filter(function (p) {
        return matchAll(hay(p, meta), q)
      })
    }

    function draw() {
      if (!grid) return
      grid.innerHTML = ''
      st.list = filt()
      var tp = Math.max(1, Math.ceil(st.list.length / per)),
        p = st.pg
      if (p > tp) p = tp
      if (p < 1) p = 1
      st.pg = p
      var slice = st.list.slice((p - 1) * per, p * per),
        cf = {
          showFits: !!cfg.show_fits_tags,
          btn: cfg.button_type || 'both',
          viewTxt: cfg.view_btn_text || 'View Part',
          atcTxt: cfg.atc_btn_text || 'Add to Cart'
        }
      slice.forEach(function (x) {
        grid.appendChild(card(x, cf, meta))
      })
      var vis = st.list.length,
        hi = vis ? (p - 1) * per + slice.length : 0,
        lo = vis ? (p - 1) * per + 1 : 0,
        nm = qEl && qEl.value.trim() ? (vis === 1 ? ' match' : ' matches') : vis === 1 ? ' part' : ' parts'
      if (cnt) {
        if (vis === 0 && data.length === 0 && st.load) cnt.textContent = 'Loading\u2026'
        else if (vis === 0) cnt.textContent = st.load ? '0\u2026' : '0 matches'
        else cnt.textContent = 'Showing ' + lo + '\u2013' + hi + ' of ' + vis + nm + ' · page ' + p + ' of ' + tp + (st.load ? ' · loading\u2026' : '')
      }
      if (em) em.style.display = vis ? 'none' : 'block'
      if (pgr) {
        pgr.classList.toggle('is-visible', tp > 1)
        if (prev) prev.disabled = p <= 1
        if (nxt) nxt.disabled = p >= tp
      }
      if (window.AOS && AOS.refresh) AOS.refresh()
    }

    function syncClearBtn() {
      if (!clr || !qEl) return
      clr.hidden = !qEl.value.trim()
    }

    var tm
    if (qEl) {
      qEl.addEventListener('input', function () {
        syncClearBtn()
        clearTimeout(tm)
        tm = setTimeout(function () {
          st.pg = 1
          draw()
        }, 160)
      })
    }
    if (clr)
      clr.addEventListener('click', function () {
        if (qEl) qEl.value = ''
        syncClearBtn()
        st.pg = 1
        draw()
        if (qEl) qEl.focus()
      })
    if (prev) prev.addEventListener('click', function () { st.pg--; draw() })
    if (nxt) nxt.addEventListener('click', function () { st.pg++; draw() })

    if (!partsH || !grid) {
      st.load = false
      draw()
      return
    }
    draw()
    fetchJSON(partsH, function (chunk) {
      data = chunk
      if (note && chunk.length >= PAGE) note.textContent = 'Loaded ' + chunk.length + ' parts\u2026'
      draw()
    })
      .then(function (all) {
        data = all
        st.load = false
        if (note) note.style.display = 'none'
        draw()
      })
      .catch(function () {
        st.load = false
        data = []
        if (note) {
          note.textContent = 'Could not load parts.'
          note.style.display = 'block'
        }
        draw()
      })
  }

  function go() {
    document.querySelectorAll('[data-replacement-parts-mount]').forEach(boot)
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go()
})()
